(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("headerItemsService", headerItemsService);

    headerItemsService.$inject = ['$q', '$state'];

    function headerItemsService($q, $state) {
        var self = this;
        var TOP_NAVIGATION_MENU = 'TOP_NAVIGATION_MENU';
        var TOP_NAVIGATION_MENU_TITLE = 'Top Navigation';

        self.ACCESS_LEVELS = {
            HARRI_HMAP: 'HARRI_HMAP',
            HARRI_ENTERPRISE: 'HARRI_ENTERPRISE',
            TEAM_LIVE: 'TEAM_LIVE'
        };

        var createPayload = function (allPreferences, keys, accessLevel) {
            var preference = {
                accessLevel: accessLevel,
                keys: keys
            }
            var value = mergePreferences(allPreferences, preference);
            var payload = {
                type: TOP_NAVIGATION_MENU,
                title: TOP_NAVIGATION_MENU_TITLE,
                filters: [
                    {
                        value: JSON.stringify(value)
                    }
                ]
            };
            return payload;
        };

        var mergePreferences = function (allPreferences, preference) {
            allPreferences = allPreferences || [];
            var existPreference = allPreferences.find(function (preferencesItem) {
                return preferencesItem.accessLevel === preference.accessLevel;
            });
            if (existPreference) {
                existPreference.keys = preference.keys;
            } else {
                allPreferences.push(preference);
            }
            return allPreferences;
        }

        var parseResult = function (data, accessLevel) {
            if (data && data.filters && data.filters[0] && data.filters[0].value) {
                var preferences = JSON.parse(data.filters[0].value);
                if (preferences.length) {
                    for (var i in preferences) {
                        if (preferences[i].accessLevel === accessLevel) {
                            return preferences[i].keys;
                        }
                    }
                    return [];
                } else {
                    return [];
                }
            } else {
                return [];
            }
        };

        self.getNavBarPreference = function (groupId, brandId, accessLevel) {
            var defer = $q.defer();
            var params = {
                type: TOP_NAVIGATION_MENU
            };
            ReportingManagementAPI
                .getTopNavigationMenu(groupId, brandId, params)
                .then(function (result) {
                    var preference = parseResult(result, accessLevel);
                    defer.resolve(preference);
                })
                .catch(function (err) {
                    defer.resolve([]);
                });
            return defer.promise;
        };

        self.updateHeaderPreferences = function (groupId, brandId, accessLevel, keys) {
            var defer = $q.defer();
            var params = {
                type: TOP_NAVIGATION_MENU
            };
            var allPreferences = [];
            ReportingManagementAPI
                .getTopNavigationMenu(groupId, brandId, params)
                .then(function (result) {
                    allPreferences = JSON.parse(result.filters[0].value)
                })
                .catch(function (err) {
                    allPreferences = [];
                })
                .finally(function () {
                    var payload = createPayload(allPreferences, keys, accessLevel);
                    ReportingManagementAPI
                        .setTopNavigationMenu(groupId, brandId, payload)
                        .then(function (result) {
                            defer.resolve(parseResult(result, accessLevel));
                        })
                        .catch(function (err) {
                            defer.reject(err);
                        });
                });
            return defer.promise;
        };

        // check sorting diff too
        self.isSameItems = function (items1, items2) {
            if (items1 == null || items2 == null) {
                return false;
            }
            if (items1.length !== items2.length) {
                return false;
            }
            var items1codes = items1
                .filter(function (item) {
                    return item.isVisible;
                })
                .map(function (item) {
                    return item.key
                });
            var items2codes = items2
                .filter(function (item) {
                    return item.isVisible;
                })
                .map(function (item) {
                    return item.key
                });
            for (var i = 0; i < items1codes.length; i++) {
                if (items1codes[i] !== items2codes[i]) {
                    return false;
                }
            }
            return true;
        };

        var processItem = function (item) {
            if (item.hideIfNoVisibleChildren) {
                item.isVisible = !!(item.subItems && item.subItems.filter(function (child) {
                    return child.isVisible;
                }).length);
            }
            else if (item.checkVisibility) {
                item.isVisible = item.checkVisibility();
            }
            if (item.checkActive) {
                item.isActive = item.checkActive();
            }
            if (item.getLabel) {
                item.label = item.getLabel();
            }
            if (item.getBadge) {
                item.badge = item.getBadge();
            }
            if (item.uiSref) {
                item.href = $state.href(item.uiSref.name, item.uiSref.params || null, item.uiSref.options || null)
            }
            if(item.subItems && item.subItems.length && item.sortableSubItems){
                item.subItems = sortItems(item.subItems);
            }
            return item;
        };

        var sortItems = function (items) {
            return _.sortBy(items, function (item) {
                return item.label;
            });
        };

        self.processHeaderItems = function (items) {
            items.forEach(function (item) {
                if (item.subItems && item.subItems.length) {
                    self.processHeaderItems(item.subItems);
                }
                processItem(item);
            });
            return items;
        };

        self.handleHeaderItemsPosition = function (headerItems, availableWidth, moreLinkWidth) {
            var currentWidth = 0;
            var previousItem;
            var allNextToMore = false;
            for (var i in headerItems) {
                var item = headerItems[i];
                if (item.isVisible) {
                    var toMore = false;
                    if (allNextToMore) {
                        toMore = true;
                    } else {
                        if ((currentWidth + item.width) >= availableWidth) {
                            toMore = true;
                        }

                        if (previousItem && (currentWidth + moreLinkWidth) >= availableWidth) {
                            previousItem.isInMore = true;
                        }
                    }

                    allNextToMore = toMore;
                    item.isInMore = toMore;
                    !toMore && (currentWidth += item.width);
                    previousItem = item;
                }
            }
            return headerItems;
        };

        self.sortHeaderItems = function (headerItems, navBarPreferences) {
            navBarPreferences = navBarPreferences || [];
            headerItems.sort(function (item1, item2) {
                if (item1.notSortable && item2.notSortable) {
                    return 0;
                }
                if (item1.notSortable) {
                    return -1;
                }
                if (item2.notSortable) {
                    return 1;
                }
                return navBarPreferences.indexOf(item1.key) - navBarPreferences.indexOf(item2.key);
            });

            return headerItems;
        };
    }
})();
